import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  paper: {
    overflow: 'hidden',
    position: 'absolute',
    width: '100%',
    top: '0px',
    right: '0px',
    height: '100%',
    backgroundImage: 'linear-gradient(#3C419A, #27284C)',
  },
  root: {
    position: 'absolute',
    top: 'calc(50% - 190px)',
    left: 'calc(50% - 303px)',
    width: '606px',
    height: '380px',
    radius: '5px',
    display: 'flex',
    justifyContent: 'center',
    ZIndexProperty: '10',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '40px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '24px',
    lineHeight: '28px',
    color: '#2C2D3E',
    ZIndexProperty: '10',
  },
  text1: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    maxWidth: '405px',
    paddingBottom: '40px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    color: '#2C2D3E',
  },
  text2: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    maxWidth: '400px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '16px',
    color: '#2C2D3E',
  },
  icon: {
    color: '#3C419A',
    position: 'relative',
    left: 'calc(50% - 30px)',
    fontSize: '60px',
    margin: '25px 0px',
  },
}));
